import { render, staticRenderFns } from "./BaseButtonInfo.vue?vue&type=template&id=379f933e&scoped=true&"
var script = {}
import style0 from "./BaseButtonInfo.vue?vue&type=style&index=0&id=379f933e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f933e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('379f933e')) {
      api.createRecord('379f933e', component.options)
    } else {
      api.reload('379f933e', component.options)
    }
    module.hot.accept("./BaseButtonInfo.vue?vue&type=template&id=379f933e&scoped=true&", function () {
      api.rerender('379f933e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseButtonInfo.vue"
export default component.exports